import { render, staticRenderFns } from "./ShopForm.vue?vue&type=template&id=43453854&scoped=true"
import script from "./ShopForm.vue?vue&type=script&lang=js"
export * from "./ShopForm.vue?vue&type=script&lang=js"
import style0 from "./ShopForm.vue?vue&type=style&index=0&id=43453854&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43453854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43453854')) {
      api.createRecord('43453854', component.options)
    } else {
      api.reload('43453854', component.options)
    }
    module.hot.accept("./ShopForm.vue?vue&type=template&id=43453854&scoped=true", function () {
      api.rerender('43453854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/ShopForm.vue"
export default component.exports